<template>
  <v-sheet max-width="1024" class="mx-auto mb-16">
    <v-carousel
      cycle
      v-model="currentSlide"
      :interval="limitMs"
      :hide-delimiters="true"
      :show-arrows="false"
      ref="carousel"
      :height="smAndDown ? 390 : 476"
    >
      <v-carousel-item
        v-for="(item, key) in slideData"
        :key="key"
      >
        <v-img
          eager
          max-width="1024"
          :height="smAndDown ? 390 : 476"
          :src="smAndDown ? item.images.cdn.sp : item.images.cdn.pc"
          :alt="item.character"
          :class="{'rounded-lg': !smAndDown}"
        >
          <v-card flat elevation="0" color="transparent" class="white--text d-flex flex-column align-center align-md-start" id="bookshelf_scan_examples">
            <v-card-title tag="h3" class="text-h5 text-md-h4 font-weight-bold pt-8 pl-5 pl-md-8 pb-2">持っている本、いくらになる？</v-card-title>
            <v-card-text class="white--text text-center text-md-left pl-8">趣味も年齢も性別もバラバラな7人の本棚。<br class="d-md-none">気になるスキャン結果をのぞいてみましょう。</v-card-text>
          </v-card>
        </v-img>
        <picture class="d-none">
          <source media="screen and (min-width:960px)" :srcset="item.images.local.pc">
          <img :id="`bookshelf-image-${item.type}`" class="bookshelf-image" :src="item.images.local.sp" :alt="item.character">
        </picture>
      </v-carousel-item>
    </v-carousel>

    <v-slide-group
      v-model="currentSlide"
      class="pa-0 mt-n14 mb-6"
      center-active
      mandatory
      :show-arrows="false"
    >
      <v-slide-item
        v-for="(item, key) in slideData"
        :key="key"
        v-slot="{ active, toggle }"
      >
        <v-card
          color="white"
          class="d-flex mx-1 rounded-lg pa-2"
          :class="{'active-slide': active}"
          :height="active ? 112 : 64"
          width="220"
          flat
          elevation="0"
          :ripple="false"
          :ref="'slide' + key"
          @click="toggle"
        >
          <v-img
            contain
            max-width="48"
            height="48"
            :src="`${cdnUrl}/assets/images/common/users/icon_${key}.png`"
          />
          <v-sheet>
            <v-card-title tag="h4" class="text-caption pa-0 font-weight-bold">{{item.character}}</v-card-title>
            <v-card-text class="text-caption pa-0">{{item.name}}（{{item.age}}歳）の本棚</v-card-text>
            <v-card-actions
              v-if="active"
              class="pa-0 pt-5 primary--text text-body-1 font-weight-bold scan-click"
              :data-shelf-type="key"
              :data-scan-file-id="item.file_id"
              @click="execSampleBookshelfScan(item.type)"
            >結果を見る<v-icon color="primary" class="ml-1" size="20px">mdi-arrow-right</v-icon></v-card-actions>
          </v-sheet>
        </v-card>
      </v-slide-item>
    </v-slide-group>
    <v-btn
      v-if="smAndDown"
      height="32"
      color="white"
      elevation="0"
      class="d-flex text-caption ml-auto grey--text text--darken-4 pr-6"
      @click="mutateScanDialog(true)"
    >
      <v-icon size="18px" class="mr-2" color="grey darken-4" style="margin-top: 2px">mdi-camera</v-icon>
      <span class="font-weight-bold">自分の本棚をスキャンしてみる</span>
    </v-btn>
    <v-btn
      v-else
      height="32"
      color="grey darken-4"
      elevation="0"
      class="d-flex text-caption ml-auto white--text barcode-start_open"
    >
      <v-icon small size="18px" class="mr-2" color="white" style="margin-top: 2px">mdi-camera</v-icon>
      <span class="font-weight-bold">自分の本棚をスキャンしてみる</span>
    </v-btn>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-sheet>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
const {mapState, mapActions, mapMutations, mapGetters} = createNamespacedHelpers('bookshelfScan');

export default {
  name: 'bookshelf-scan',
  data() {
    return {
      cdnUrl: VueConfig.cdn_url,
      limitMs: 6000,
      currentSlide: 0,
      slideData: VueConfig.topScanSamples,
      scanSamples: VueConfig.topScanSamples,
      overlay: false,
    }
  },
  methods: {
    ...mapMutations([
      'mutateBookshelfScanImageFile',
      'resetScanResult',
      'mutateScanDialog'
    ]),
    ...mapActions([
      'updateBookshelfScanImage',
      'createSampleFileObject',
      'saveStorage'
    ]),
    async execSampleBookshelfScan(type) {
      try {
        this.overlay = true;
        this.resetScanResult();

        const blob = await this.createSampleFileObject(this.scanSamples[type].images.cdn.pc);
        const file = new File([blob], 'filename.png', { type: 'image/png' });
        await this.saveStorage(file);
        this.mutateBookshelfScanImageFile(file);
        await this.updateBookshelfScanImage(file);
        location.href = '/spa/estimate/search';
      } catch (e) {
        this.overlay = false;
      }

    },
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapGetters([
      'getScanDialog'
    ]),
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .active-slide {
    border: 3px solid #009098 !important;
  }
  .scan-click {
    &:before {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
  }
  .v-carousel__controls {
    bottom: 64px;
    background-color: transparent;
  }
  .v-slide-group {
    &__content {
      align-items: center;
      padding: 0 456px;
    }
    &__prev,
    &__next {
      display: none;
    }
  }
  .v-card--link:focus:before {
    opacity: 0;
  }
}

</style>